import React from "react";
import { Link } from "react-router-dom";
import { XCircle } from "lucide-react";
import { Button } from "../components/ui/button";

export default function PaymentCancel() {
  return (
    <div className="max-w-2xl mx-auto px-6 py-24 text-center">
      <div className="h-16 w-16 rounded-full bg-secondary flex items-center justify-center mx-auto mb-6">
        <XCircle className="h-8 w-8 text-muted-foreground" />
      </div>
      <h1 className="font-serif text-3xl md:text-4xl mb-3">Pagamento cancelado</h1>
      <p className="text-muted-foreground mb-8">
        A tua compra não foi concluída. Os artigos continuam no teu carrinho — podes tentar novamente quando quiseres.
      </p>
      <div className="flex gap-3 justify-center">
        <Link to="/checkout"><Button className="rounded-full h-12 px-8">Voltar ao checkout</Button></Link>
        <Link to="/loja"><Button variant="outline" className="rounded-full h-12 px-8">Continuar a comprar</Button></Link>
      </div>
    </div>
  );
}
